<template>
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <p>{{ loadingText }}</p>
    </div>
  </template>

  <script>
  export default {
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      loadingText: {
        type: String,
        default: 'Loading...'
      }
    },
    data() {
      return {
        isLoading: this.loading
      };
    },
    watch: {
      loading(newVal) {
        this.isLoading = newVal;
      }
    }
  };
  </script>

  <style scoped>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .loading-spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid #fff;
    width: 50px;
    height: 50px;
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  p {
    margin-left: 8px;
  }
  </style>
